/**
 * Specifies a predefined size for a modal window.
 */
export enum ModalSize {
    /** The modal window will be smaller than the default size. */
    small = <any>'sm',

    /** The modal window will be the default size. */
    default = <any>'default',

    /** The modal window will be larger than the default size. */
    medium = <any>'md',

    /** The modal window will be larger than the medium size. */
    large = <any>'lg',

    /** The modal window will be largest size. */
    extraLarge = <any>'xlg',

    /** The modal window will fill the entire window 95% */
    full95Percent = <any>'full95Percent',

    /** The modal window will fill the entire window. */
    full = <any>'full',
}
